import { render, staticRenderFns } from "./drag_dialog.vue?vue&type=template&id=1d888ea8&scoped=true&"
import script from "./drag_dialog.vue?vue&type=script&lang=js&"
export * from "./drag_dialog.vue?vue&type=script&lang=js&"
import style0 from "./drag_dialog.vue?vue&type=style&index=0&id=1d888ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d888ea8",
  null
  
)

export default component.exports